/*
 * ぶっちゃけパンダ 楽天アフィリエイトリンクのクリック計測
 * 記事内の a.afl-button クリックを GA4 イベント(affiliate_click)として送信。
 * GA4(gtag) が読み込まれている場合のみ動作。未設定でもエラーにはならない。
 */
(function () {
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a.afl-button');
    if (!link) return;
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'affiliate_click', {
        link_url: link.href,
        link_text: (link.textContent || '').trim().slice(0, 100),
        page_path: window.location.pathname,
      });
    }
  });
})();
